import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'checklist',
    label: 'Checklist',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
